<template>
    <el-form  :model="phoneInfo" :rules="rules" ref="phoneInfo" class="sendCode"  :class="codeInfo.codeName" :label-width="showLableWidth(codeInfo.codeName)" >
    <el-form-item  class="infoInput" v-if="userEmailLevel==='5'">
      <div style="display: flex;align-items: center;gap: 5px;">
        <el-input :value="studentNo" disabled>
          <template slot="prepend">
            负责人学工号:
            <el-tooltip class="item" effect="dark" content="如果负责人学工号有变动请联系邮箱管理员或者65989006" placement="top">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </template>
        </el-input>

      </div>
    </el-form-item>
    <el-form-item class="infoInput" prop="phone" :label="showLable(codeInfo.codeName)" :error="codeInfo.errorPhone" >
      <div style="display: flex;align-items: center;">
        <div class="phone-label">手机号：</div>
        <el-select
          v-model="phoneInfo.originalPhone"
          @change="handlePhoneSelect"
          style="width: 100%; "
          placeholder="请选择手机号"
        >
          <el-option
            v-for="item in contactList"
            :key="item.originalPhone"
            :label="item.maskedPhone"
            :value="item.originalPhone"
          >
          </el-option>
        </el-select>
      </div>
      <!-- <el-input v-else placeholder="11位手机号" v-model="phoneInfo.phone" maxlength="11">
        <el-select v-model="phoneInfo.phone_addr" slot="prepend" class="input-with-select" popper-class="input-with-options" placeholder="请选择">
          <el-option
            v-for="item in phone_citys"
            :key="item.value"
            :label="item.label"
            :value="item.value">
            <span class="label">{{ item.label }}</span>
            <span class="value">{{ item.value }}</span>
          </el-option>
        </el-select>
          <template slot="prepend">
            手机号:
          </template>
      </el-input> -->
    </el-form-item>

    <div class="infoInput clear">
      <el-form-item class="yzCode"  :error="codeInfo.errorMsg">


            <el-input placeholder="请输入图形验证码" v-model="phoneInfo.pCode" @change="handlerPcode" maxlength="4">      </el-input>
        <div class="btn-yzCode fr">
        <img  :src="captchaImage" @click="refreshCaptchaImage()"  height="40" width="100">

      </div>
      </el-form-item>

    </div>


    <div class="infoInput clear">
      <el-form-item class="yzCode" prop="code" @keyup.enter.native="submitForm()" :label="showCodeLable(codeInfo.codeName)" :error="codeInfo.errorMsg">


        <el-input class="fl" v-model="phoneInfo.code" placeholder="请输入验证码" maxlength="6"></el-input>
        <div class="btn-yzCode fr">
          <el-button  id="btn-yzCode-first" :class="{ yzcodeActive: phoneInfo.checkPhone && phoneInfo.checkPcode }" v-show="verCode.btnShow" @click="getCode()">获取验证码</el-button>
          <el-button v-show="!verCode.btnShow" class="btn-yzCode-second">重新获取({{ verCode.time }})</el-button>
      </div>
      </el-form-item>
   <!-- <img  :src="captchaImage" @click="refreshCaptchaImage()"  > -->
    </div>
  </el-form >
</template>

<script>
import {checkCode} from '../config/formCheck'
import GetCode from '../config/getCode'
export default {
  name: "sendCode",
  props: ['codeInfo','contactList','userEmailLevel','studentNo'],
  created () {
      this.changeFlageEdit = this.codeInfo.codeName

      this.refreshCaptchaImage() ;
  },
  watch: {
    changeFlageEdit: function (newValue) {
      localStorage.setItem("codeTime","0")
    },
    contactList(newVal){
      if(newVal.length>0){
        if(this.userEmailLevel==='5'){
          this.phoneInfo.phone = newVal[0].maskedPhone
          this.phoneInfo.originalPhone = newVal[0].originalPhone
        }else{
          const xgh =localStorage.getItem("findPwdXGH");
          newVal.forEach(item => {
            if(item.userId===xgh){
              this.phoneInfo.phone = item.maskedPhone
              this.phoneInfo.originalPhone = item.originalPhone
            }
          })
        }
      }
    }
  },
  data(){
    const phone = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;


    //检查手机号
    const checkPhones = (rule, value, callback) => {
      let phoneNumber = value.replace(/\s+/g, "");
      if (!phoneNumber) {
        this.phoneInfo.checkPhone = false;
        return callback(new Error("手机号不能为空"));
      } else if (phoneNumber.length != 11) {
        setTimeout(() => {
          this.phoneInfo.checkPhone = false;
          callback(new Error("手机号码输入有误"));
        }, 100);
      } else {
        setTimeout(() => {
          // 处理脱敏手机号，移除中间的****
          if (phoneNumber.includes('****')) {
            // 对于脱敏手机号，只验证前三位和后四位是否为数字
            const firstThree = phoneNumber.substring(0, 3);
            const lastFour = phoneNumber.substring(7);
            if (!/^\d{3}$/.test(firstThree) || !/^\d{4}$/.test(lastFour)) {
              this.phoneInfo.checkPhone = false;
              callback(new Error("手机号码输入有误"));
              return;
            }
            // 脱敏手机号验证通过
            this.phoneInfo.checkPhone = true;
            callback();
          } else {
            // 正常手机号验证
            if (!phone.test(parseInt(phoneNumber))) {
              this.phoneInfo.checkPhone = false;
              callback(new Error("手机号码输入有误"));
            } else {
              this.phoneInfo.checkPhone = true;
              callback();
            }
          }
        }, 100);
      }
    };
    return {
      changeFlageEdit:"",
      phoneInfo:{
        checkPhone: false,
        checkPcode: false,
        phone: "",
        phone_addr: "+86",
        code: "",
      },
      captchaImage: "",
      pTime:"",
      submitRegForm:true,
      verCode: {
        btnShow: true,
        time: 30
      },
      phone_citys: [
        {
          value: "中国",
          label: "+86"
        },
        {
          value: "中国香港",
          label: "+852"
        },
        {
          value: "中国澳门",
          label: "+853"
        },
        {
          value: "中国台湾",
          label: "+886"
        },
        {
          value: "美国/加拿大",
          label: "+1"
        }
      ],
      rules: {
          phone:[
             { validator: checkPhones, trigger: 'change' }
          ],
          phone_addr:[
             { required: true, message: '请选择正确的归属地', trigger: 'change' }
          ],
          code:[
             { validator: checkCode, trigger: 'change' }
          ]
        },
      }
    },
    methods:{
      querySearch(queryString, cb) {
        var results = queryString ? this.contactList.filter(this.createFilter(queryString)) : this.contactList;
        // 调用 callback 返回建议列表的数据
        let arr = []
        results.forEach((item) => {
          arr.push({value:item.originalPhone,label:item.maskedPhone})
        })
        cb(arr);
      },
      createFilter(queryString) {
        return (contact) => {
          return contact.originalPhone.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
        };
      },
      submitForm(){
        this.$emit('submitRegForm');
      },
       validatePhone(callback) {
          this.$refs['phoneInfo'].validate((vaild)=>{
            callback(vaild)
          })
      },
      resetForm(){
        this.$refs['phoneInfo'].resetFields();
      },
      handleFocus() {
        // 主动调用查询方法，获取匹配的候选数据
        this.querySearch(this.inputValue, (results) => {
          // 通过ref获取组件实例，手动控制面板显示
          const autoCompleteInstance = this.$refs.autocompleteRef;
          if (autoCompleteInstance) {
            autoCompleteInstance.suggestionDisabled=true
            autoCompleteInstance.suggestions = results; // 设置候选列表
          }
        });
      },
      handlePhoneSelect(value){
        // 当选择手机号时，更新显示值为脱敏格式
        this.phoneInfo.phone = value.substring(0, 3) + '****' + value.substring(7);
      },
      handlePhoneChange(item){
        if(item.length==11){
          this.phoneInfo.phone=item.substring(0,3)+"****"+item.substring(7)
        }
        this.phoneInfo.originalPhone = item
      },
      formatStudentNo(studentNo){
        //保留第一位与最后一位，其余全部为*
        return studentNo.substring(0,1)+"*".repeat(studentNo.length-2)+studentNo.substring(studentNo.length-1)
      },
      handlerPcode() {
        if (this.phoneInfo.pCode !="" && this.phoneInfo.pCode.length == 4) {
          this.phoneInfo.checkPcode = true;
        } else {
           this.phoneInfo.checkPcode = false;
        }


      },
      // clear(val){
      //   console.log(val)
      //   if(val == "code"){
      //     this.codeInfo.errorMsg = ""
      //   }else if(val == "phone"){
      //     this.phoneErr = ""
      //   }else{
      //     return false
      //   }
      // },
      showLableWidth(value){
        if(value=="regCode"){
          return "80px"
        }
      },
      showLable(value){
      if(value=="regCode"){
          return "手机号"
        }
      },
      showCodeLable(value){
      if(value=="regCode"){
          return "验证码"
        }
      },
      refreshCaptchaImage () {

        var self = this
        self.pTime = new Date().getTime();
        self.captchaImage  = "https://mail-mgmt.tongji.edu.cn:8081/email/createImageCode?t=" + self.pTime;

      },

        // 验证码调用接口
        getCode(){
          var self = this
          self.verCode.btnShow = false
          const phoneNumber =self.phoneInfo.originalPhone
          const pCode = self.phoneInfo.pCode
          const t = self.pTime
          if( phoneNumber && self.phoneInfo.checkPhone && self.phoneInfo.checkPcode){
            GetCode.getCode( self.verCode,function (t) {
            // console.log(t)
            self.verCode.time = t
            if( t === 0 ){
               self.verCode.btnShow = true
              }
            })

            const url = '/email/getRandomCode?phoneNo='+phoneNumber+'&pCode='+pCode+'&t='+t
            self.postRequest(url,{}).then((result)=>{
            if(result.data){
              if(result.data.msgStatus == 0){
                self.$alert(result.data.msgCode, '错误提示', {
                  confirmButtonText: '确定',
                  type: 'error',
                  center: true,
                  customClass:'errMessage'
                });
              }


            }
            })
          }else{
            self.verCode.btnShow = true
            return false
          }
        },
    },
    mounted: function () {
      this.$nextTick(function () {
        const self = this;
        const codeTime = localStorage.getItem("codeTime")
        if(codeTime&&codeTime!=0){
            self.verCode.btnShow = false
            self.verCode.time = codeTime
            GetCode.getCode( self.verCode,function (t) {
            // console.log(t)
            self.verCode.time = t
            if( t === 0 ){
               self.verCode.btnShow = true
              }
            })
        }
        if(this.phoneInfo.phone){
             const valids = this.$refs.phoneInfo
            valids.validateField('phone', valid => {
              console.log("valid:",valid)
            })
        }
      })
    }
};
</script>

<style scoped>
.infoForm {
  margin-top: 38px;
}
.phone-label{
  width: 100px;
  background-color: #f5f7fa;
  color: #909399;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border: 1px solid #dcdfe6;
  text-align: center;
  height: 39px;
  border-right: 0;
}
.infoInput {
  width: 308px;
  height: 41px;
  margin: 0 auto;
  margin-top: 20PX;
}
.forgetPwd .infoInput:nth-of-type(2){
  margin-top: 30px;
}
.input-with-select {
  width: 85px;
  color: #3b4248;
}

.yzCode .el-input{
  width: 63%;
}
  .btn-yzCode  button{
    padding: 12px 7px;
    background: #ccc;
    color: #fff;
    border-radius: 3px;
    display: block;
    cursor: not-allowed;
  }
  .btn-yzCode .yzcodeActive{
    background: #198bfd;
    color: #fff;
    cursor: pointer;
  }
  .yzcodeActive:focus{
       background: #409EFF;
    }
  .yzcodeActive:hover{
       background: #409EFF;
    }
  .btn-yzCode-second{
      padding: 12px 6px;
    }


.problemCode .infoInput{
  width: 382px;
  min-height: 60px;
  height: auto;
  margin: 0 auto;
  margin-top: 18px;
}
.problemCode .input-with-select {
  width: 85px;
  color: #3b4248;
}
.problemCode .input-with-options {
  width: 200px;
}
.problemCode .input-with-options .label {
  display: block;
  width: 60px;
  float: left;
}
.problemCode .input-with-options .value {
  display: block;
  float: left;
}
.problemCode .btn-yzCode  button{
    padding: 12px 15px;
    height: 50px;
    background: #ccc;
    color: #fff;
    border-radius: 3px;
    display: block;
    cursor: not-allowed;
  }

.problemCode .yzCode .el-input{
  width: 70%;
}

.problemCode .btn-yzCode .yzcodeActive{
    background: #198bfd;
    color: #fff;
    cursor: pointer;
  }
.problemCode .btn-yzCode .yzcodeActive:focus{
       background: #409EFF;
    }
.problemCode .btn-yzCode .yzcodeActive:hover{
       background: #409EFF;
    }
.problemCode .btn-yzCode  .btn-yzCode-second{
      padding: 12px 6px;
    }

/deep/ .el-select .el-input__inner{
  border-top-left-radius: unset;
  border-bottom-left-radius: unset;
}

.regEmail .infoInput{
  width: 460px;
  min-height: 60px;
  height: auto;
  margin: 0 auto;
  margin-top: 10px;
}
.regEmail .infoInput:first-child{
  margin-top: 55px;
}
.regEmail .input-with-select {
  width: 85px;
  color: #3b4248;
}
.regEmail .input-with-options {
  width: 200px;
}
.regEmail .input-with-options .label {
  display: block;
  width: 60px;
  float: left;
}
.regEmail .yzCode .el-input{
  width: 70%;
}

</style>
<style>
  .regEmail .btn-yzCode .el-form-item__content{
    margin-left: 0 !important;
  }

</style>



// WEBPACK FOOTER //
// src/public/sendCode.vue